import { styled } from '@mui/material/styles';
import { Box, CircularProgress } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import NavbarWrapperLayout from './NavbarWrapperLayout';
import ToolbarLayout from './ToolbarLayout';
import CountingLayout from './CountingLayout';
import { useAuthCore } from '../../core/modules/auth';
import { useMeCore } from '../../core/modules/me';
import Users from '../screens/dashboad/users/Users';
import { SIGNIN } from '../../core/router/routes';
import User from '../screens/dashboad/users/User';
import Welcome from '../screens/dashboad/Welcome';
import { ToastContainer } from 'react-toastify';
import MeCompanies from '../screens/dashboad/meCompanies/MeCompanies';
import CompanyMetrics from '../screens/dashboad/meCompanies/CompanyMetrics';
import UserDialog from '../components/UserDialog';
import AiChatWidget from '../components/aiChat/AiChatWidget';
//import MeCompanies from '../screens/dashboad/meCompanies/MeCompanies';
//import CompanyMetrics from '../screens/dashboad/meCompanies/CompanyMetrics';
import Companies from '../screens/dashboad/companies/Companies';
import Company from '../screens/dashboad/companies/Company';
import ChangePasswordDialog from '../components/ChangePasswordDialog';
import CompanyImport from '../screens/dashboad/import/ExcelImporter';
// import CompanyReports from '../screens/dashboad/meCompanies/CompanyReports'; // COMENTADO - Reemplazado por ReportsDashboard (Tarea 4 - 23/03/2026)
import ReportsDashboard from '../screens/dashboad/reports/ReportsDashboard';
import CompanySettings from '../screens/dashboad/meCompanies/CompanySettings';
import ManageUsers from '../screens/dashboad/users/ManageUsers';
import MetricDetailsDashboard from '../screens/dashboad/metricDetails/MetricDetailsDashboard';
import StockConsultantPage from '../screens/dashboad/stockConsultant/StockConsultantPage';
import InventoryCountAdminPage from '../screens/dashboad/inventoryCount/InventoryCountAdminPage';
import StockComparisonPage from '../screens/dashboad/stockComparison/StockComparisonPage';
import ReconciliationScreen from '../screens/dashboad/inventoryCount/ReconciliationScreen';

const Root = styled('div')(() => ({
  '& .container': {
    maxWidth: '1570px',
    width: '100%',
    margin: '0 auto',
  },
}));

const Layout = () => {
  const { token } = useAuthCore();
  const { user } = useMeCore();

  if (!token) {
    return <Navigate to={SIGNIN} replace />;
  }

  // Esperamos a que se resuelva el usuario antes de elegir el layout, para
  // no mostrar por un instante el layout normal a un Tomador de Inventario.
  if (!user) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // El rol "Tomador de Inventario" solo ve el modulo de toma de inventario,
  // nunca el resto de Inventaria.
  if (user.role === 'Tomador de Inventario') {
    return (
      <Routes>
        <Route path="/counting/*" element={<CountingLayout />} />
        <Route path="*" element={<Navigate to="/dashboard/counting" replace />} />
      </Routes>
    );
  }

  return (
    <Root id="fuse-layout" className="w-full flex">
      <ToastContainer />
      <div className="flex flex-auto min-w-0">
        <NavbarWrapperLayout />

        <main
          id="fuse-main"
          className="flex flex-col flex-auto min-h-full min-w-0 relative z-10"
        >
          <ToolbarLayout className="fixed" />

          <div className="flex flex-col flex-auto min-h-0 relative z-10">
            <Routes>
              <Route index element={<Welcome />} />
              <Route path="/me/companies" element={<MeCompanies />} />
              <Route path="/metrics/:id" element={<CompanyMetrics />} />
              <Route path="/metric-details/:id/:metricType/:startDate/:endDate" element={<MetricDetailsDashboard />} />
              <Route path="/stock-consultant/:id" element={<StockConsultantPage />} />
              <Route path="/inventory-count/:id" element={<InventoryCountAdminPage />} />
              <Route path="/inventory-count/:id/sessions/:sessionId/reconciliation" element={<ReconciliationScreen />} />
              <Route path="/stock-comparison/:id" element={<StockComparisonPage />} />
              <Route path="/import/:id" element={<CompanyImport />} />
              <Route path="/reports/:id" element={<ReportsDashboard />} />
              <Route path="/settings/:id" element={<CompanySettings />} />
              <Route path="/manage-users/:id" element={<ManageUsers/>} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/:id" element={<User />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/companies/:id" element={<Company />} />
            </Routes>
          </div>
        </main>
      </div>
      <UserDialog />
      <ChangePasswordDialog />
      <AiChatWidget />
    </Root>
  );
};

export default Layout;
